export enum PlanJourEveType {
    VIDE = 'V',
    EVENEMENT = 'E',
    CONGES = 'C'
}